import { render, staticRenderFns } from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=template&id=2164ed57&scoped=true"
import script from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
export * from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
import style0 from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=style&index=0&id=2164ed57&prod&lang=scss&scoped=true"
import style1 from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=style&index=1&id=2164ed57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164ed57",
  null
  
)

export default component.exports